<div class="response-container">
	<div class="titleContainer">
		<h2>Subscribers</h2>
	</div>
	<div class="infoContainer">
		<div class="analytic-card grid grid-cols-4 tablet:grid-cols-2">
			<ng-container *ngIf="!['Mobile Justice'].includes(app)">
				<div class="summary-card">
					<portals-loading [showIf]="formLoading">
						<mat-card class="incidents">
							<mat-card-content fxLayout="row" fxLayoutAlign="space-between center" class="project">
								<img class="sub-detail-image" src="/assets/images/total_subscribers.png" />
								<div class="sub-detail text-right" fxFlex>
									<div>
										<h2>
											{{ totalCount | count }}
										</h2>
										<small>Total Subscribers</small>
									</div>
								</div>
							</mat-card-content>
						</mat-card>
					</portals-loading>
				</div>
			</ng-container>
			<div class="summary-card">
				<portals-loading [showIf]="formLoading">
					<mat-card class="incidents">
						<mat-card-content fxLayout="row" fxLayoutAlign="space-between center" class="national">
							<img class="sub-detail-image" src="/assets/images/avg_follow.png" />
							<div class="sub-detail text-right" fxFlex>
								<div>
									<h2>
										{{ averageData.average_daily_follows | numberFormat }}
									</h2>
									<small>Average Daily Follows</small>
								</div>
							</div>
						</mat-card-content>
					</mat-card>
				</portals-loading>
			</div>
			<div class="summary-card">
				<portals-loading [showIf]="formLoading">
					<mat-card class="videos">
						<mat-card-content fxLayout="row" fxLayoutAlign="space-between center" class="national">
							<img class="sub-detail-image" src="/assets/images/growth_rate.png" />
							<div class="sub-detail text-right" fxFlex>
								<div>
									<h2>
										{{ growthData.growth_rate | percentFormat }}
									</h2>
									<small>Growth Rate</small>
								</div>
							</div>
						</mat-card-content>
					</mat-card>
				</portals-loading>
			</div>
			<div class="summary-card">
				<portals-loading [showIf]="formLoading">
					<mat-card class="videos">
						<mat-card-content fxLayout="row" fxLayoutAlign="space-between center" class="national">
							<img class="sub-detail-image" src="/assets/images/streak.png" />
							<div class="sub-detail text-right" fxFlex>
								<div>
									<h2>{{ streakData.streak_length }} Days</h2>
									<small>Follow Streak</small>
								</div>
							</div>
						</mat-card-content>
					</mat-card>
				</portals-loading>
			</div>
		</div>
		<div id="chart">
			<portals-loading [showIf]="formLoading">
				<portals-line [lineChartData]="lineChartData" [lineChartOptions]="lineChartOptions" [lineChartLegend]="lineChartLegend" [lineChartPlugins]="lineChartPlugins"></portals-line>
			</portals-loading>
		</div>

		<div class="bottom-card" fxLayout="row" fxLayoutAlign="space-between center">
			<div fxLayout="row" fxLayoutAlign="space-between center">
				<span>Subscribers as of</span>
				<span>{{ currentFilters.startDate | date }} - {{ currentFilters.endDate | date }}</span>
			</div>
		</div>
	</div>
</div>
